const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/utils/pdf.ts';
import { addSVGDrawingOptionsDefaults, SVGDrawingOptions } from '../components/PDFViewer/DrawingArea';
import { LineCapStyle, PDFDocument, rgb } from 'pdf-lib';

export const downloadBase64PDF = (base64PDF: string, filename: string) => {
    const pdfBlob = base64ToBlob(base64PDF);
    const pdfURL = createBlobURL(pdfBlob);
    downloadPDF(pdfURL, filename);
};

const base64ToBlob = (base64String: string): Blob => {
    const byteCharacters = atob(base64String);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: 'application/pdf' });
};

const createBlobURL = (blob: Blob): string => {
    return URL.createObjectURL(blob);
};

const downloadPDF = (pdfURL: string, filename: string) => {
    const downloadLink = document.createElement('a');
    downloadLink.href = pdfURL;
    downloadLink.download = filename;
    downloadLink.style.display = 'none';
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
};

export async function addDrawingToPDF(
    pdfString: string,
    svgString: string,
    svgDrawingOptions: SVGDrawingOptions,
    page: number, // actual page number, not zero-indexed
    scale: number
) {
    if (!Number.isInteger(page) || page < 1) {
        throw new Error(`Page number must be a positive integer. Received: ${page}`);
    }

    const pdfDoc = await PDFDocument.load(pdfString);

    const pages = pdfDoc.getPages();

    const pageIndex = page - 1; // convert to zero-indexed
    if (pageIndex >= pages.length) {
        throw new Error(`Invalid page number: ${page}. PDF has ${pages.length} pages.`);
    }

    const selectedPage = pages[pageIndex];
    const { width, height } = selectedPage.getSize();
    const signatureRE = /d="([^"]+)"/g;
    const scaleFactor = 100.0 / scale;
    let match: RegExpExecArray | null = signatureRE.exec(svgString);
    while (match !== null) {
        const { penColor, penWidth } = addSVGDrawingOptionsDefaults(svgDrawingOptions);

        selectedPage.drawSvgPath(match[1], {
            x: 0,
            y: height,
            scale: scaleFactor,
            borderColor: rgb(penColor!.r, penColor!.g, penColor!.b),
            borderLineCap: LineCapStyle.Round,
            borderWidth: penWidth! / scaleFactor,
        });
        match = signatureRE.exec(svgString);
    }

    const newPdf = await pdfDoc.saveAsBase64();
    return newPdf;
}
